if (!window.Eurus.loadedScript.includes('cart-stickers.js')) {
  window.Eurus.loadedScript.push('cart-stickers.js');

  var STICKERS_VARIANT_ID = 56124210250106;

  window.Eurus.stickersManager = {
    processing: false,
    checkedThisPage: false,

    isOptedOut: function() {
      return localStorage.getItem('stickers_opt_out') === 'true';
    },

    addStickers: function(callback) {
      var self = this;
      if (this.processing) return;
      this.processing = true;

      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var hasStickers = cart.items.some(function(item) { return item.variant_id === STICKERS_VARIANT_ID; });
          var otherItems = cart.items.filter(function(item) { return item.variant_id !== STICKERS_VARIANT_ID; });

          if (!hasStickers && otherItems.length > 0) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({ items: [{ id: STICKERS_VARIANT_ID, quantity: 1 }] })
            }).then(function(response) {
              if (!response.ok) {
                console.error('Stickers: impossible d\'ajouter (status ' + response.status + ')');
              }
              if (callback) callback(response.ok);
            });
          } else if (hasStickers && otherItems.length === 0) {
            var stickerItem = cart.items.find(function(item) { return item.variant_id === STICKERS_VARIANT_ID; });
            var line = cart.items.indexOf(stickerItem) + 1;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: line, quantity: 0 })
            }).then(function(response) {
              if (callback) callback(response.ok);
            });
          } else {
            if (callback) callback(false);
          }
        })
        .catch(function(e) {
          console.error('Stickers error:', e);
          if (callback) callback(false);
        })
        .finally(function() {
          self.processing = false;
        });
    },

    removeStickers: function(callback) {
      var self = this;
      this.processing = true;

      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var stickerItem = cart.items.find(function(item) { return item.variant_id === STICKERS_VARIANT_ID; });
          if (stickerItem) {
            var line = cart.items.indexOf(stickerItem) + 1;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: line, quantity: 0 })
            }).then(function() {
              if (callback) callback();
            });
          } else {
            if (callback) callback();
          }
        })
        .catch(function(e) {
          console.error('Stickers remove error:', e);
          if (callback) callback();
        })
        .finally(function() {
          self.processing = false;
        });
    },

    refreshCartPage: function() {
      var sectionsToRender = Alpine.store('xCartHelper').getSectionsToRender();
      var sections = sectionsToRender.map(function(s) { return s.id; }).join(',');
      fetch(window.location.pathname + '?sections=' + sections)
        .then(function(response) { return response.json(); })
        .then(function(response) {
          sectionsToRender.forEach(function(section) {
            var el = document.querySelector(section.selector);
            if (el && response[section.id]) {
              el.innerHTML = getSectionInnerHTML(response[section.id], section.selector);
            }
          });
          Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
        });
    }
  };

  // When items change (product added from any page), silently add stickers
  document.addEventListener('eurus:cart:items-changed', function() {
    var mgr = window.Eurus.stickersManager;
    if (!mgr.isOptedOut()) {
      mgr.addStickers();
    }
  });

  requestAnimationFrame(function() {
    document.addEventListener('alpine:init', function() {
      Alpine.data('xCartStickers', function() {
        return {
          optOut: false,
          loading: false,

          init: function() {
            this.optOut = localStorage.getItem('stickers_opt_out') === 'true';
            var mgr = window.Eurus.stickersManager;

            // On the cart page only, ensure stickers and refresh display
            if (!this.optOut && !mgr.checkedThisPage && document.getElementById('main-cart-items')) {
              mgr.checkedThisPage = true;
              mgr.addStickers(function(added) {
                if (added) mgr.refreshCartPage();
              });
            }
          },

          toggleOptOut: function() {
            this.optOut = !this.optOut;
            this.loading = true;
            localStorage.setItem('stickers_opt_out', this.optOut.toString());
            var self = this;
            var mgr = window.Eurus.stickersManager;
            var isCartPage = !!document.getElementById('main-cart-items');

            if (this.optOut) {
              mgr.removeStickers(function() {
                if (isCartPage) {
                  mgr.refreshCartPage();
                } else if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                }
                self.loading = false;
              });
            } else {
              mgr.checkedThisPage = false;
              mgr.addStickers(function(added) {
                if (isCartPage) {
                  mgr.refreshCartPage();
                } else if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                }
                self.loading = false;
              });
            }
          }
        };
      });
    });
  });

  // ─── Drawer checkbox auto-injection ────────────────────────────────
  // MoonBundle replaces the cart drawer HTML, removing the Liquid checkbox.
  // We re-inject a vanilla JS version into MoonBundle's footer.
  (function() {
    var mgr = window.Eurus.stickersManager;
    var _busy = false;
    var _timer = null;

    // Hide quantity +/- buttons for stickers, keep input visible as readonly
    var style = document.createElement('style');
    style.textContent =
      '.moonbundle-quantity-btn[data-item-key^="' + STICKERS_VARIANT_ID + '"]' +
      '{ display:none !important; }' +
      '.moonbundle-quantity-input[data-item-key^="' + STICKERS_VARIANT_ID + '"]' +
      '{ pointer-events:none; opacity:.6; }';
    document.head.appendChild(style);

    function buildCheckbox() {
      var wrap = document.createElement('div');
      wrap.id = 'stickers-optout-drawer-js';
      wrap.style.cssText = 'padding:12px 16px 0';

      var row = document.createElement('div');
      row.className = 'flex items-start eurus';

      var cb = document.createElement('input');
      cb.id = 'x-stickers-optout-drawer';
      cb.type = 'checkbox';
      cb.className =
        'checkbox-checked cursor-pointer border ' +
        'checked:border-[rgba(var(--colors-text-link))] checked:bg-[rgba(var(--colors-text-link))] ' +
        'rounded';
      cb.style.cssText = 'position:relative; width:16px; height:16px; min-width:16px; margin-right:8px; margin-top:2px;';
      cb.checked = mgr.isOptedOut();

      var lbl = document.createElement('label');
      lbl.htmlFor = 'x-stickers-optout-drawer';
      lbl.className = 'cursor-pointer text-sm leading-snug';
      lbl.innerHTML =
        'Je ne souhaite pas recevoir les supers stickers Emancipées gratuitement ' +
        '<span class="text-xs opacity-75">(si vous les avez déjà ou s\'ils ne vous ' +
        'intéressent pas, vous n\'avez qu\'à cocher cette case pour éviter du gaspillage)</span>';

      function findStickerItem() {
        var btn = document.querySelector('[data-item-key^="' + STICKERS_VARIANT_ID + '"]');
        if (!btn) return null;
        // Walk up to the direct child of .moonbundle-cart-drawer-items (individual line item)
        var el = btn;
        while (el.parentElement) {
          if (el.parentElement.classList.contains('moonbundle-cart-drawer-items')) return el;
          el = el.parentElement;
        }
        return null;
      }

      cb.addEventListener('change', function() {
        cb.disabled = true;
        localStorage.setItem('stickers_opt_out', String(cb.checked));

        // Toggle visibility of stickers line item
        var item = findStickerItem();
        if (item) item.style.display = cb.checked ? 'none' : '';

        // API call in background
        if (cb.checked) {
          mgr.removeStickers(function() { cb.disabled = false; });
        } else {
          mgr.addStickers(function() { cb.disabled = false; });
        }
      });

      row.appendChild(cb);
      row.appendChild(lbl);
      wrap.appendChild(row);
      return wrap;
    }

    function inject() {
      if (_busy) return;

      // Already present → skip
      if (document.querySelector('#stickers-optout-drawer-js')) return;

      // MoonBundle renders its drawer outside #CartDrawer
      var footer = document.querySelector('#moonbundle-cart-drawer .moonbundle-cart-drawer-footer');
      if (!footer) return;

      _busy = true;
      footer.insertBefore(buildCheckbox(), footer.firstChild);
      _busy = false;
    }

    function setup() {
      var mbDrawer = document.getElementById('moonbundle-cart-drawer');
      if (!mbDrawer) return false;

      inject();

      // Auto-add stickers on first drawer load if not opted out
      if (!mgr.isOptedOut()) {
        mgr.addStickers();
      }

      new MutationObserver(function() {
        if (_busy) return;
        clearTimeout(_timer);
        _timer = setTimeout(inject, 200);
      }).observe(mbDrawer, { childList: true, subtree: true });

      return true;
    }

    // MoonBundle's drawer loads async — poll until it appears
    var _setupDone = false;
    var _waitTimer = setInterval(function() {
      if (!_setupDone) {
        _setupDone = setup();
        if (_setupDone) clearInterval(_waitTimer);
      }
    }, 500);
  })();
}